/*
 * @Description: 微前端
 * @Date: 2025-01-04 10:27:17
 * @LastEditTime: 2025-01-04 13:18:46
 */
export const isMicroAppEnv = !!window.__MICRO_APP_ENVIRONMENT__;
export const microData = window.__MICRO_APP_ENVIRONMENT__ && window.microApp.getData();